<template functional>
    <div>
        <p>Cancel all scheduled payments for the customer.</p>
    </div>
</template>

<script>
    export default {
        name: 'cancel-scheduled-payments-summary',
    };
</script>
